interface GaugeRingProps {
	percent: number
	color: string
}

export function GaugeRing({ percent, color }: GaugeRingProps) {
	const filledDeg = Math.max(0, Math.min(100, percent)) * 2.7

	return (
		<div className='relative h-[110px] w-[110px] shrink-0'>
			<div
				className='absolute inset-0 rounded-full'
				style={{
					background: `conic-gradient(from 135deg, ${color} 0deg ${filledDeg}deg, hsl(var(--border)) ${filledDeg}deg 270deg, transparent 270deg 360deg)`,
				}}
			/>
			<div className='absolute inset-[10px] rounded-full bg-background' />
			<div className='absolute inset-0 flex items-center justify-center'>
				<span className='text-[28px] font-semibold tracking-[-0.16px] text-foreground'>{percent}%</span>
			</div>
		</div>
	)
}
